import React from 'react';
import { Activity } from '../../../types';
import { Glass3dCard } from '../../ui/glass-3d-card';
import { StatefulButton } from '../../ui/stateful-button';
import { useProductCardCartActions } from '../useProductCardCartActions';

export const HomeActivityCard: React.FC<{
  activity: Activity;
  t: (key: string) => string;
  onBookActivity: (activity: Activity) => void;
}> = ({ activity, t, onBookActivity }) => {
  const cart = useProductCardCartActions(
    {
      type: 'activity',
      itemId: activity.id,
      itemName: activity.name,
      itemPrice: activity.price,
    },
    t
  );

  const meta = `${activity.duration} · ${t('common.upTo') || 'Up to'} ${activity.capacity}`;

  return (
    <Glass3dCard
      title={activity.name}
      text={activity.description}
      meta={meta}
      imageSrc={activity.images?.[0] || null}
      isAvailable={activity.isAvailable !== false}
      availableLabel={t('common.available') || 'Available'}
      unavailableLabel={t('common.unavailable') || 'Unavailable'}
      viewMoreLabel={t('common.viewDetails') || 'View more'}
      viewMoreHref={`/webdesigned/activities/${activity.id}`}
      isLiked={cart.isLiked}
      isFavorite={cart.isFavorite}
      isInCart={cart.isInCart}
      onLike={cart.onLike}
      onFavorite={cart.onFavorite}
      onCart={cart.onCart}
      likeTitle={cart.likeTitle}
      favoriteTitle={cart.favoriteTitle}
      cartTitle={cart.cartTitle}
      primaryAction={
        <StatefulButton
          className="min-w-0 bg-[#1e5c34] px-3 py-1.5 text-xs font-semibold hover:ring-[#1e5c34]"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onBookActivity(activity);
          }}
        >
          {t('common.quickBook')}
        </StatefulButton>
      }
    />
  );
};
